/**
 * Server-corrected clock. Command envelopes carry `issuedAt`; a phone whose clock drifted would
 * see its commands rejected as `not-yet-valid`/`expired`. The hub's `welcome.serverTime` (or an
 * HTTP `Date` header) sets the offset. A lying server can at worst expire its own relays
 * (docs/signing.md §7).
 */
let offset = 0

export const clock = {
  now: () => Date.now() + offset,
  setServerTime(serverMs: number, localMs = Date.now()) {
    const o = serverMs - localMs
    // Ignore sub-second jitter; clamp absurd values (±1 day) as a guard against a bad frame.
    if (Math.abs(o) > 1_000 && Math.abs(o) < 86_400_000) offset = o
    else if (Math.abs(o) <= 1_000) offset = 0
  },
  get offset() {
    return offset
  },
}
